import { forwardRef } from 'react';

interface InkStrokeProps {
  className?: string;
  align?: 'center' | 'left';
}

const InkStroke = forwardRef<HTMLDivElement, InkStrokeProps>(
  ({ className = '', align = 'center' }, ref) => {
    return (
      <div
        ref={ref}
        className={`w-full max-w-xs ${
          align === 'left' ? 'ink-stroke-left' : 'ink-stroke mx-auto'
        } ${className}`}
      />
    );
  }
);

InkStroke.displayName = 'InkStroke';

export default InkStroke;